module.exports = __webpack_public_path__ + "img/05.e5985103.png";